import { AnnouncementBar } from "./AnnouncementBar";
import { CandyMarquee } from "./CandyMarquee";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

export function Layout({ children }) {
  return (
    <>
      <AnnouncementBar />
      <CandyMarquee />
      <Nav />
      <main className="min-h-[70vh]">{children}</main>
      <Footer />
    </>
  );
}
